<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form" @submit.prevent="buscarFaq">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Pergunta"
              v-model="form.filters.pergunta"
              outlined
              dense
              maxlength="300"
              hide-details
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-submit-button></sca-submit-button>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterFaq()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="noDataText"
        show-expand
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.pergunta`]="{ item }">
          <p class="text-wrap mx-70vw">{{ item.pergunta }}</p>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <p class="ml-4 my-0 text-wrap mx-70vw">
              {{ item.resposta }}
            </p>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarFaq(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterFaq(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarFaq(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarFaqDialog
      :visible="dialogManterFaq.visible"
      :content="dialogManterFaq.content"
      :edit="dialogManterFaq.edit"
      @onClose="dialogManterFaq.close()"
      @onSave="buscarFaq()"
    ></CadastrarEditarFaqDialog>
    <VisualizarFaqDialog
      v-if="dialogVisualizarFaq.visible"
      :visible="dialogVisualizarFaq.visible"
      :content="dialogVisualizarFaq.content"
      @onClose="dialogVisualizarFaq.close()"
    ></VisualizarFaqDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Faq } from '~/commons/classes/faq';
import FaqService from '~/services/faq.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarFaqDialog from "./dialogs/CadastrarEditarFaqDialog.vue";
import VisualizarFaqDialog from "./dialogs/VisualizarFaqDialog.vue";

export default {
  name: "ManterFaqView",
  mixins: [FaqService, datatablesMixin],
  components: {
    CadastrarEditarFaqDialog,
    VisualizarFaqDialog,
  },
  data: () => ({
    dialogManterFaq: Dialog.Build(),
    dialogVisualizarFaq: Dialog.Build(),
    form: {
      filters: {
        pergunta: null,
        ativo: null,
      },
      isLoading: false,
      expanded: [],
    },
    table: {
      headers: [
        { text: 'Pergunta', align: 'left', value: 'pergunta' },
        { text: 'Resposta', align: 'center', value: 'data-table-expand' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
    },
  }),
  methods: {
    buscarFaq() {
      if(this.$validarFormulario()) {
        this.form.isLoading = true;
        this.$buscarFaqs({ params: this.form.filters })
        .then(({ data }) => (this.table.itens = data.itens))
        .finally(() => this.form.isLoading = false);
      }
    },
    openDialogManterFaq(faq) {
      faq
        ? this.$visualizarFaq(faq).then(
          ({ data }) => this.dialogManterFaq.open(new Faq(data.resposta), true))
        : this.dialogManterFaq.open(Faq.Build());
    },
    openDialogVisualizarFaq(faq) {
      this.$visualizarFaq(faq).then(
        ({ data }) => this.dialogVisualizarFaq.open(new Faq(data.resposta)));
    },
    inativarAtivarFaq(faq) {
      this.$swal({
        text: `Deseja ${faq.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarFaq(faq.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarFaq();
        });
      });
    },
    resetForm() {
      this.table.itens = [];
      this.$clearFilters(this.form.filters);
      this.expanded = [];
    },
  },
};
</script>
